module.exports = __webpack_public_path__ + "static/media/small-logo.0f3b53f7.svg";